import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type OrderWithinState = string;

export const ORDER_WITHIN = (
  Details: React.ComponentType<ConditionTypeDetailsProps<OrderWithinState>>,
): ConditionType<OrderWithinState, Condition.OrderWithin> => ({
  name: "Time since order",
  description(state) {
    return `Within ${+state} days of order`;
  },
  Details(props: ConditionTypeDetailsProps<OrderWithinState>) {
    return React.createElement(Details, props);
  },
  empty: String(30),
  fromModel(model) {
    return String(model.duration.total("days"));
  },
  toModel(state) {
    return {
      type: Condition.ORDER_WITHIN,
      duration: Temporal.Duration.from({ days: +state }),
    };
  },
  valid(state) {
    return +state >= 0;
  },
});
